import { gql } from '@apollo/client';

export const CREATE_QUESTION_TYPE = gql`
  mutation createQuestionType($input: CreateQuestionTypeInput!) {
    questionType {
      create(input: $input) {
        id
        name
        sectionId
        domainId
        skillId
      }
    }
  }
`;

export const UPDATE_QUESTION_TYPE = gql`
  mutation updateQuestionType($input: UpdateQuestionTypeInput!) {
    questionType {
      update(input: $input) {
        id
        name
        sectionId
        domainId
        skillId
      }
    }
  }
`;
